if (!customElements.get('media-grid-video-trigger')) {
  class MediaGridVideoTrigger extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector('button');
      if (!this.button) return;
      this.button.addEventListener('click', this.openModal.bind(this));
    }

    openModal() {
      const selector = this.getAttribute('data-modal');
      if (!selector) return;
      const modal = document.querySelector(selector);
      if (!modal || typeof modal.show !== 'function') return;

      modal.show(this.button);

      const video = modal.querySelector('video');
      if (!video) return;
      try { video.currentTime = 0; } catch (e) {}
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }
  }

  customElements.define('media-grid-video-trigger', MediaGridVideoTrigger);

  document.body.addEventListener('modalClosed', () => {
    document.querySelectorAll('.media-grid-video-modal video').forEach((video) => {
      video.pause();
      try { video.currentTime = 0; } catch (e) {}
    });
  });
}
